/**
 * Formatter to format number to currency value ( GBP )
 */
 const formatter = new Intl.NumberFormat('en-UK', {
    style: 'currency',
    currency: 'GBP',
});

/**
 * Calculating the branches cost based on the number of branches.
 * @param branchNumber
 */
const calculateBranchesCost = async (branchNumber) => {
    const priceBase = 399;
    const priceBaseSingleBranch = 50;

    if (branchNumber < 3) {
        return priceBase;
    }

    return priceBase + priceBaseSingleBranch * (branchNumber - 2);
};

/**
 * Calculating the solicitors cost based on the number of solicitors.
 * @param solicitorNumber
 */
const calculateSolicitorsCost = async (solicitorNumber) => {
    const priceBase = 399;
    const priceBaseSolicitors = 50;

    if (solicitorNumber <= 3) {
        return 150;
    } if (solicitorNumber >= 4 && solicitorNumber <= 9) {
        return 299;
    } if (solicitorNumber >= 10 && solicitorNumber <= 30) {
        return priceBase;
    }

    let qualifier = solicitorNumber % 30 === 0
        ? Math.floor(solicitorNumber / 30) - 1
        : Math.floor(solicitorNumber / 30);

    return priceBase + priceBaseSolicitors * qualifier;

};

/**
 * Calculating the firm cost based on the number of branch and the number of solicitors.
 * @param branchNumber
 * @param solicitorNumber
 */
 const calculateFirmCost = async (branchNumber, solicitorNumber) => {

    // if (branchNumber === 0 && solicitorNumber === 0) {
    //     return formatter.format(0);
    // }

    const solicitorsCost = await calculateSolicitorsCost(solicitorNumber);
    const branchesCost = await calculateBranchesCost(branchNumber);
    const nextTotal = branchNumber <= 2
        ? solicitorsCost
        : Math.max(solicitorsCost, branchesCost);

    // return formatter.format(nextTotal);

    return nextTotal > 1500 ? 'Enterprise' : nextTotal;
};


$(() => {
    const calculatePrice = async () => {
        const feeEarnersValues = {
            '1': 3,
            '2': 9,
            '3': 30,
            '4': 60,
            '5': 90,
            '6': 120,
            '7': 150,
            '8': 180,
            '9': 210,
            '10': 240,
            '11': 270,
            '12': 300,
            '13': 330,
            '14': 360,
            '15': 390,
            '16': 420,
            '17': 450,
            '18': 480,
            '19': 510,
            '20': 540,
            '21': 570,
            '22': 600,
            '23': 630,
            '24': 660,
            '25': 690,
            '26': 691,
        };

        const maxPriceBoundaries = {
            150: {
                branches: 2,
                solicitors: 3
            },
            299: {
                branches: 3,
                solicitors: 9
            },
            399: {
                branches: 3,
                solicitors: 30
            },
            449: {
                branches: 3,
                solicitors: 60
            },
            499: {
                branches: 4,
                solicitors: 90
            },
            549: {
                branches: 5,
                solicitors: 120
            },
            599: {
                branches: 6,
                solicitors: 150
            },
            649: {
                branches: 7,
                solicitors: 180
            },
            699: {
                branches: 8,
                solicitors: 210
            },
            749: {
                branches: 9,
                solicitors: 240
            },
            799: {
                branches: 10,
                solicitors: 270
            },
            849: {
                branches: 11,
                solicitors: 300
            },
            899: {
                branches: 12,
                solicitors: 330
            },
            949: {
                branches: 13,
                solicitors: 360
            },
            999: {
                branches: 14,
                solicitors: 390
            },
            1049: {
                branches: 15,
                solicitors: 420
            },
            1099: {
                branches: 16,
                solicitors: 450
            },
            1149: {
                branches: 17,
                solicitors: 480
            },
            1199: {
                branches: 18,
                solicitors: 510
            },
            1249: {
                branches: 19,
                solicitors: 540
            },
            1299: {
                branches: 20,
                solicitors: 570
            },
            1349: {
                branches: 21,
                solicitors: 600
            },
            1399: {
                branches: 22,
                solicitors: 630
            },
            1449: {
                branches: 23,
                solicitors: 660
            },
            1499: {
                branches: 24,
                solicitors: 690
            },
            'Enterprise': {
                branches: 25,
                solicitors: 691
            }
        };

        const branchesAmount = parseInt($('#numberOfBranches').val());
        const feeEarnersAmount = feeEarnersValues[$('#numberOfFeeEarners').val()];
        const priceAmount = $('.section-6__pricing-calculator-monthly-price-amount--amount');
        const subtextText = $('.section-6__pricing-calculator-monthly-price-subtext-text');
        const featureTableRsPriceAmount = $('.section-6__feature-table-rs-price');

        const calculated = await calculateFirmCost(branchesAmount, feeEarnersAmount);

        if (calculated === 'Enterprise') {
            priceAmount.text(calculated)
            subtextText.text('Please contact us');
        } else {
            priceAmount.text('£' + calculated);

            subtextText.html(`Inclusive of up to ${maxPriceBoundaries[calculated].branches} locations and up to ${maxPriceBoundaries[calculated].solicitors} solicitors.`);
        }

        featureTableRsPriceAmount.text(calculated);
    };

    calculatePrice();

    $('#numberOfBranches').niceSelect();
    $('#numberOfFeeEarners').niceSelect();

    const numberOfBranchesSlider = $('#numberOfBranchesSlider');
    const numberOfFeeEarnersSlider = $('#numberOfFeeEarnersSlider');

    numberOfBranchesSlider.rangeslider({
        polyfill: false, // DON'T CHANGE THIS!
        onSlide: (position, value) => {
            $('#numberOfBranches').val(value);
            $('#numberOfBranches').niceSelect('update');
            calculatePrice();
        }
    });

    numberOfFeeEarnersSlider.rangeslider({
        polyfill: false, // DON'T CHANGE THIS!
        onSlide: (position, value) => {
            $('#numberOfFeeEarners').val(value);
            $('#numberOfFeeEarners').niceSelect('update');
            calculatePrice();
        }
    });

    $('.section-6__pricing-calculator-input-container--branches').on('change', 'select', function() {
        numberOfBranchesSlider.val(this.value).change();
        calculatePrice();
    });
    $('.section-6__pricing-calculator-input-container--feeEarners').on('change', 'select', function() {
        numberOfFeeEarnersSlider.val(this.value).change();
        calculatePrice();
    });
});
